import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { OrderHeadGet } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-hours',
    templateUrl: './order-head-hours.component.html',
    styleUrls: ['./order-head-hours.component.css'],
})
export class OrderHeadHoursComponent implements OnChanges {
    @Input()
    public get?: OrderHeadGet;

    public selectedTransferTab = 'NOTTRANSFERRED';

    public powtimesGrid?: GridOptions;

    public transferGrid?: GridOptions;

    public onTabChanged() {
        if (!this.get) return;

        if (this.get.gb_orderhead_hours_sub === 'REGISTRATIONS') {
            this.readPowtimesGrid();
        } else if (this.get.gb_orderhead_hours_sub === 'TRANSFER_TO_ORDER') {
            this.readTransferGrid();
        }
    }

    public readPowtimesGrid() {
        this.powtimesGrid?.gridfunc?.read();
    }

    public readTransferGrid() {
        if (!this.transferGrid) {
            this.transferGrid = new Grid().setRememberId('w_orderhead_powtimes_to_order_grid').setLoadDataFunction({ method: 3644, parameters: () => ({ order_internal_no: this.get?.order_internal_no, gb_orderhead_hours_sub_transfer_to_order_sub: this.selectedTransferTab }) });
        } else {
            this.transferGrid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['get']) {
            this.onTabChanged();
        }
    }
}
